"use client";
import { useTranslations } from "next-intl";
import Image from "next/image";
import { Rating } from "../Rating/Rating";
import { Reviews } from "../Reviews/Reviews";
import Stars from "../Stars/Stars";

type Props = {
	companyReview?: {
		score: number;
		count: number;
	};
};

export const StarsWithImage = ({ companyReview }: Props) => {
	const t = useTranslations("Rating");

	if (!companyReview?.score) return null;
	return (
		<div
			className="flex items-center justify-center gap-5"
			aria-label={`${t("accessibilityRating")} ${companyReview.score} / ${companyReview.count}`}
		>
			<Image
				src="/assets/additional/kiyoh-logo.png"
				alt="Kiyoh"
				width={100}
				height={68}
				loading="lazy"
				unoptimized // this is not a Storyblok image, so we can't optimize it need to optimize it
			/>
			<Stars
				classes={{ parent: "font-bold text-main" }}
				rating={companyReview.score / 2}
				link={true}
				inlineMode={false}
			>
				{companyReview?.score && (
					<Rating link={true} rating={companyReview.score} />
				)}
				{companyReview?.count && (
					<Reviews totalReviews={companyReview?.count} link={true} />
				)}
			</Stars>
		</div>
	);
};

export default StarsWithImage;
